/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { entity } from 'projects/icemedx-lib/src/models/common/entity';
import { contact } from '../common/contact';
import { address } from '../common/address';
import { identification } from '../common/identification';
import { basecode } from '../ehr/subs/basecode';
import { subscriberreference } from '../ehr/subs/subscriberreference';

export class patient extends IceEntity {
  trans_account: string = "";
  patient_type_key: string = "";
  ethnicity_code: string = "";
  entity_key: string = "";
  address_key: string = "";
  login_user_name: string = "";
  report_exempt_type: string = "";
  does_not_take_medication: boolean = false;
  smoking: boolean = false;
  record_version: number = 0;
  offline_record_status: number = 0;
  accessed: any = NaN;
  accessed_user: string = "";
  created: any = NaN;
  created_user: string = "";
  modified: any = NaN;
  modified_user: string = "";

  ENTS: entity[] = [];
  CONS: contact[] = [];
  ADS: address[] = [];
  IDS: identification[] = [];
  SUBS: subscriberreference[] =[];
  COUNTRIES: basecode[] = [];
  CURRENCIES: basecode[] = [];

  constructor() {
      super();
  }

  getName(): string {
    let ret = "";
    let entAry = this.ENTS.filter(e => e.entity_key == this.entity_key);
    if (entAry != null && entAry.length > 0)
      ret = entAry[0].getdisplayname(false);
    return ret;
  }

  gettablename(): string {
      return "PATIENT";
  }

  hassubtree(ColumnName: string): boolean {
    if (ColumnName.length == 0) return false;
    else if (ColumnName == "CONS") return true;
    else if (ColumnName == "ADS") return true;
    else if (ColumnName == "ENTS") return true;
    else if (ColumnName == "IDS") return true;
    else if (ColumnName == "SUBS") return true;
    else if (ColumnName == "ACTS") return true;
    else if (ColumnName == "PROVS") return true;
    else if (ColumnName == "MERGES") return true;
    else if (ColumnName == "COUNTRIES") return true;
    else if (ColumnName == "CURRENCIES") return true;

    return false;
  }

  getsubtreetablename(ColumnName: string): string {
    if (ColumnName.length == 0) return null;
    else if (ColumnName == "CONS") return "CONTACT";
    else if (ColumnName == "ADS") return "ADDRESS";
    else if (ColumnName == "ENTS") return "ENTITY";
    else if (ColumnName == "IDS") return "IDENTIFICATION";
    else if (ColumnName == "SUBS") return "SUBSCRIBER_REFERENCE";
    else if (ColumnName == "ACTS") return "TRANS_ACCOUNT_REFERENCE";
    else if (ColumnName == "PROVS") return "PROVIDER_REFERENCE";
    else if (ColumnName == "MERGES") return "MERGE";
    else if (ColumnName == "COUNTRIES") return "COUNTRY";
    else if (ColumnName == "CURRENCIES") return "CURRENCY";

    return null;
  }
}
